module.exports = __webpack_public_path__ + "img/album21_22.757dba70.jpg";